import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mosque"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 4C14.7614 4 17 6.23858 17 9H20V21H4V9H7C7 6.23858 9.23858 4 12 4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 21V15H15V21H9Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 21V15H15V21H9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 9V21H20V9M4 9H3M4 9H7M20 9H21M20 9H17M7 9H17M7 9C7 6.23858 9.23858 4 12 4M17 9C17 6.23858 14.7614 4 12 4M12 4L12.002 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Mosque = Vue.extend<IconProps>({
  name: 'MosqueIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'mosque',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Mosque;
